import stringsToSymbols from "@/util/strings-to-symbols.mjs";

export const RANK_SYMBOLS = stringsToSymbols([
  "platinumPlus",
  "challenger",
  "grandmaster",
  "masterPlus",
  "master",
  "diamondPlus",
  "diamond",
  "emeraldPlus",
  "emerald",
  "platinum",
  "gold",
  "silver",
  "bronze",
  "iron",
]);
